import React from 'react'
import styled from '@emotion/styled'

import { fontSize2XSmall } from '../../constants/principles'

import DoneModal from '../generic/modals/DoneModal'
import { ModalContentNormal } from '../generic/Basics.js'

export default ({ setShowModal }) => (
  <DoneModal name={'ineligibleDef'} title={'What makes a vehicle ineligible for an offer?'} maxWidth={360} onClick={e => setShowModal(false)} informational={true}>
    <ModalContentNormal>
      <ModalText>
        It could be a lot of things. Some vehicles are rare, so there aren't enough vehicles for a good sales history. Certain equipment (especially vehicle modifications) can make a vehicle ineligible or maybe the vehicle has title issues, poor condition,
        or mileage over 300,000.
      </ModalText>
    </ModalContentNormal>
  </DoneModal>
)

const ModalText = styled.div`
  font-size: ${fontSize2XSmall};
  padding: 8px 0;
`
